import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    // Écouter les changements d'état d'authentification Firebase
    const unsubscribe = authService.onAuthStateChange((firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });

    // Cleanup subscription on unmount
    return () => unsubscribe && unsubscribe();
  }, []);

  const login = async (username, password) => {
    try {
      const u = await authService.login({ username, password });
      setUser(u);
      return u;
    } catch (error) {
      console.error('Login error in context:', error);
      throw error;
    }
  };

  const logout = async () => {
    try {
      await authService.logout();
      setUser(null);
    } catch (error) {
      console.error('Logout error in context:', error);
      throw error;
    }
  };

  return (
    <AuthContext.Provider value={{
      user,
      login,
      logout,
      isAuthenticated: () => !!user,
      isAdmin: () => user?.role === 'ADMIN',
      isLoading
    }}>
      {children}
    </AuthContext.Provider>
  );
}